const ɵ0 = () => import("./../module/cms-default/cms-default.module.ngfactory").then(mod => mod.CmsDefaultModuleNgFactory), ɵ1 = () => import("./../module/cms-normal/cms-normal-01/cms-normal-01.module.ngfactory").then(mod => mod.CmsNormal01ModuleNgFactory), ɵ2 = () => import("./../module/cms-normal/cms-normal-02/cms-normal-02.module.ngfactory").then(mod => mod.CmsNormal02ModuleNgFactory), ɵ3 = () => import("./../module/cms-single/cms-single-01/cms-single-01.module.ngfactory").then(mod => mod.CmsSingle01ModuleNgFactory), ɵ4 = () => import("./../module/cms-web/cms-web-01/cms-web-01.module.ngfactory").then(mod => mod.CmsWeb01ModuleNgFactory), ɵ5 = () => import("./../module/cms-mailbox/cms-mailbox-01/cms-mailbox-01.module.ngfactory").then(mod => mod.CmsMailbox01ModuleNgFactory);
export const cmsWidgets = [
    {
        path: 'cms-default',
        loadChildren: ɵ0
    },
    {
        path: 'cms-normal-01',
        loadChildren: ɵ1
    },
    {
        path: 'cms-normal-02',
        loadChildren: ɵ2
    },
    {
        path: 'cms-single-01',
        loadChildren: ɵ3
    },
    {
        path: 'cms-web-01',
        loadChildren: ɵ4
    },
    {
        path: 'cms-mailbox-01',
        loadChildren: ɵ5
    },
];
export function cmsArrayToObj() {
    const result = {};
    for (const w of cmsWidgets) {
        result[w.path] = w.loadChildren;
    }
    return result;
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
